"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImuType = void 0;
var ImuType;
(function (ImuType) {
    ImuType[ImuType["Other"] = 0] = "Other";
    ImuType[ImuType["MPU9250"] = 1] = "MPU9250";
    ImuType[ImuType["MPU6500"] = 2] = "MPU6500";
    ImuType[ImuType["BNO080"] = 3] = "BNO080";
    ImuType[ImuType["BNO085"] = 4] = "BNO085";
    ImuType[ImuType["BNO055"] = 5] = "BNO055";
    ImuType[ImuType["MPU6050"] = 6] = "MPU6050";
    ImuType[ImuType["BNO086"] = 7] = "BNO086";
    ImuType[ImuType["BMI160"] = 8] = "BMI160";
    ImuType[ImuType["ICM20948"] = 9] = "ICM20948";
    ImuType[ImuType["ICM42688"] = 10] = "ICM42688";
    ImuType[ImuType["BMI270"] = 11] = "BMI270";
    ImuType[ImuType["LSM6DS3TRC"] = 12] = "LSM6DS3TRC";
    ImuType[ImuType["LSM6DSV"] = 13] = "LSM6DSV";
    ImuType[ImuType["LSM6DSO"] = 14] = "LSM6DSO";
    ImuType[ImuType["LSM6DSR"] = 15] = "LSM6DSR";
    ImuType[ImuType["ICM45686"] = 16] = "ICM45686";
    ImuType[ImuType["ICM45605"] = 17] = "ICM45605";
    ImuType[ImuType["ADC_RESISTANCE"] = 18] = "ADC_RESISTANCE";
    ImuType[ImuType["DEV_RESERVED"] = 250] = "DEV_RESERVED";
})(ImuType = exports.ImuType || (exports.ImuType = {}));
